import axios from "api/axios"
import {
  APIResponse,
  Config,
  ConfigWithURLParams,
  NoContentType,
  PaginatedAPIResponse,
} from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import {
  CartlessOrder,
  CheckoutOrder,
  InvoiceAttachment,
  Order,
  OrderItemDetails,
  ProductDetails,
  PromocodeResponse,
} from "./types"
import { urls } from "./urls"

export default {
  listOrders: async ({
    params,
  }: Config): Promise<PaginatedAPIResponse<Order[]>> => {
    try {
      const res = await axios.get(urls.orders.base(), { params })
      return formatSuccessResponse(res, { paginatedResponse: true })
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  getOrderDetails: async ({
    urlParams,
  }: ConfigWithURLParams): Promise<APIResponse<OrderItemDetails>> => {
    try {
      const res = await axios.get(urls.orders.detail(urlParams.id))
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },

  getProductDetails: async ({
    urlParams,
  }: ConfigWithURLParams): Promise<APIResponse<ProductDetails>> => {
    try {
      const res = await axios.get(urls.orders.getProductDetails(urlParams.id))
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },

  getInvoice: async ({
    urlParams,
  }: ConfigWithURLParams): Promise<APIResponse<InvoiceAttachment>> => {
    try {
      const res = await axios.get(urls.orders.invoice(urlParams.transactionId))
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  checkout: async ({ data }: Config): Promise<APIResponse<CheckoutOrder>> => {
    try {
      const res = await axios.post(urls.orders.base(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  createOrder: async ({
    data,
  }: Config): Promise<APIResponse<CartlessOrder>> => {
    try {
      const res = await axios.post(urls.orders.create(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  getCartlessOrder: async ({
    data,
  }: Config): Promise<APIResponse<CartlessOrder>> => {
    try {
      const res = await axios.get(urls.orders.create(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },

  applyPromocode: async ({
    data,
    urlParams,
  }: ConfigWithURLParams<"orderId">): Promise<
    APIResponse<PromocodeResponse>
  > => {
    try {
      const res = await axios.put(urls.orders.detail(urlParams.orderId), data)
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },

  userless: {
    createOrder: async ({
      data,
    }: Config): Promise<
      APIResponse<{ order: CartlessOrder; token: string }>
    > => {
      try {
        const res = await axios.post(urls.userlessOrders.create(), data)
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
    attachUser: async ({
      data,
    }: Config): Promise<APIResponse<NoContentType>> => {
      try {
        const res = await axios.post(urls.userlessOrders.attachUser(), data)
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },
}
